import { useState } from 'react';
import { faqList } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[360px_1fr] lg:gap-12">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-600">
              <i className="ri-question-answer-line" />
              FAQ
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-600">
              下载、安装与使用中最常遇到的疑问，点开即可查看解决办法。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-customer-service-2-line text-primary-600" />
                仍未解决？
              </p>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                可在帮助中心提交问题描述与截图，我们会给出针对性的排查建议。
              </p>
              <button
                type="button"
                className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line" />
                提交问题
              </button>
            </div>
          </div>

          <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {faqList.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="flex items-center gap-3 text-sm font-medium text-foreground-950 md:text-base">
                      <span className="font-heading text-xs text-primary-600">
                        Q{String(idx + 1).padStart(2, '0')}
                      </span>
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <p className="px-4 pb-4 text-xs leading-relaxed text-foreground-600 md:px-5 md:pl-[3.4rem]">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}